import { CardList } from "./card-list";
/**
 * Product Preview Card - Shows products in chat after AI response
 * Uses the generic CardList component
 */
export class ProductPreviewCard {
    /**
     * Create product preview card element
     */
    static create(products, onViewProducts) {
        // Convert products to card list items
        const items = products.map((product) => ({
            id: product.product_id,
            image: product.coverImage,
            title: product.product_name,
            subtitle: product.brand_name,
        }));
        // Use the generic CardList component
        return CardList.create({
            items,
            title: `Found ${products.length} ${products.length === 1 ? "product" : "products"} for you`,
            actionLabel: "View products",
            onAction: () => onViewProducts(products),
        });
    }
}
